import * as React from 'react'

import { Carat, ExpansionPanel, RotateClockwise } from '@syconium/little-miss-figgy'

import { textWithFilterCount } from '../../utils'

import { Body, Details, Label, Summary, SummaryWrap } from './styles'

export const FilterInputSegment: React.FC<{
  filterCount: number
  isExpandedInitially?: boolean
  label: string
  onExpand?: () => void
  selectedFilterCount: number
  children?: React.ReactNode
}> = ({
  children,
  filterCount,
  isExpandedInitially = false,
  label,
  selectedFilterCount,
  onExpand,
}) => {
  if (filterCount === 0) return null
  const transition = '0.6s'

  return (
    <Body>
      <ExpansionPanel.Container animate={true} isExpanded={isExpandedInitially} onChange={onExpand}>
        <SummaryWrap>
          <ExpansionPanel.Summary
            expandIcon={isExpanded => (
              <Carat
                rotateClockwise={
                  isExpanded ? RotateClockwise.QuarterReverse : RotateClockwise.Quarter
                }
                transition={transition}
              />
            )}
          >
            <Summary>
              <Label asTag='h3' textTransform='uppercase'>
                {textWithFilterCount(label, selectedFilterCount)}
              </Label>
            </Summary>
          </ExpansionPanel.Summary>
        </SummaryWrap>
        <ExpansionPanel.Details>
          <Details>{children}</Details>
        </ExpansionPanel.Details>
      </ExpansionPanel.Container>
    </Body>
  )
}
